(function () {
    'use strict';

    angular.module('sempraWebapp').factory('VouchersViewModel', vouchersViewModelFactory);

    /** @ngInject */
    function vouchersViewModelFactory ($translate) {
        function VouchersViewModel() {
            this.email = '';
            this.amount = 1;

            this.amountOfTokens = 1;
            this.amountOfVouchers = 1;
            this.newVoucherPrefix = '';
            this.voucherValidityDays = '7';

            this.data = [];
            this.orderBy = 'id';
            this.order = 'desc';
            this.page = 1;
            this.total = 0;
            this.pageSize = 10;
            this.pageOptions = [5, 10, 15];
            this.selected = [];
            this.pagerTranslations = {
                page: $translate.instant('GRID_PAGER_PAGE'),
                rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
                of: $translate.instant('GRID_PAGER_PAGE_OF')
            };

            this.printVoucherPrefix = '';
            this.vouchersForPrint = [];

            this.voucherCodeFilter = '';
            this.expiresAt = null;  // ZonedDateTime from backend (ISO 8601 string)

        }

        VouchersViewModel.prototype.destroy = function () {

        };

        VouchersViewModel.prototype.onTokensCreatedSuccessHandler = function () {
          this.email = '';
        };

        VouchersViewModel.prototype.onVouchersCreatedSuccessHandler = function () {
            this.newVoucherPrefix = '';
        };

        VouchersViewModel.prototype.refreshVouchersHistory = function (data) {
            this.data = data.content;
            this.total = data.totalElements;
        };

        VouchersViewModel.prototype.sortChanged = function(order){
            var orderQuery = getOrderObject(order);
            this.orderBy = orderQuery.orderBy;
            this.order = orderQuery.order;
        };

        VouchersViewModel.prototype.paginationChanged = function(page, limit){
            this.page = page;
            this.pageSize = limit;
        };

        // helper function
        function getOrderObject(order) {
            var result = {
                order: 'asc',
                orderBy: order
            };

            if (order.indexOf('-') > -1) {
                result.order = 'desc';
                result.orderBy = order.substring(1);
            }
            return result;
        }

        return VouchersViewModel;
    }
})();